export const DH = {
  Widget: {
    RootWrapper: 'ecw-root-wrapper',
    ResourceLoader: 'ecw-resource-loader',
    PMList: 'ecw-payment-method-list',
    MorePoWrapper: 'ecw-more-po-wrapper',
    // @deprecated HorizontalLayoutHeader
    HorizontalLayoutHeader: 'ecw-horizontal-layout-header',
    HorizontalLayoutDivider: 'ecw-horizontal-layout-divider',
    HorizontalLayoutFieldset: 'ecw-horizontal-layout-fieldset',
  },
  GooglePay: {
    Button: 'ecw-google-pay-view-btn',
  },
  ApplePay: {
    Button: 'ecw-apple-pay-view-btn',
  },
  PayPal: {
    MockButtonPayPal: 'ecw-mock-btn-paypal',
    MockButtonPayPalCredit: 'ecw-mock-btn-credit',
    MockButtonPayLater: 'ecw-mock-btn-paylater',
    ButtonWrapperPayPal: 'ecw-button-wrapper-paypal',
    ButtonWrapperCredit: 'ecw-button-wrapper-credit',
    ButtonWrapperPayLater: 'ecw-button-wrapper-paylater',
  },
  MorePaymentOptions: {
    Wrapper: 'ecw-more-payment-options-wrapper',
    Button: 'ecw-more-payment-options-button',
  },
};
